<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import { getRadarList } from '@/api/modules/home'

definePage({
  name: 'market-radar',
  meta: {
    title: '异动雷达',
  },
})
// const refsList = useTemplateRef('refsList') as any
const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
const active = ref(0)

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

const tabsList = ref([
  {
    name: '全部',
    val: 0,
  },
  {
    name: '自选',
    val: 1,
  },
])

const type = ref(0)

function onTabChange(val: any) {
  type.value = Number(val ? 0 : 1)
  nextTick(() => {
    // if (refsList.value) {
    //   refsList.value.reLoad()
    // }
    onLoad()
  })
}

const list = ref([])
const loading = ref(false)
const finished = ref(false)
async function onLoad() {
  try {
    const { status, data } = await getRadarList({
      page: 1,
      type: type.value,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page" :search="false">
    <template #navbar-end>
      <FmIcon name="tdesign:setting" class="text-24px color-[#fff]" />
    </template>
    <div ref="refTabConten" class="tab-conten" :style="{ top: navbarHeight }">
      <Notice />
      <van-tabs v-model:active="active" line-width="9px" @change="onTabChange">
        <van-tab v-for="item in tabsList" :key="item.val" :title="item.name" />
      </van-tabs>
      <!-- <van-notice-bar left-icon="volume-o" color="#333" background="#fff" text="港股通共588只，最近调整生效日是2025/12/23" /> -->
    </div>
    <div class="h-[100%] bg-[#fff]">
      <div :style="{ height: `${tabContenHeight}px` }" />
      <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="bg-[#fff]">
          <!-- <div class="m-b-8px m-l-8px m-r-8px flex items-center justify-between text-11px">
            <div class="flex items-center color-[#999]">
              <span>更新：{{ date }}</span>
            </div>
            <div class="flex items-center justify-between gap-10px p-b-8px p-t-8px">
              <div class="flex items-center justify-between">
                <span>全部市场</span>
                <FmIcon name="material-symbols:expand-more-rounded" class="text-lg color-[#666]" />
              </div>
              <div class="flex items-center justify-between">
                <span>标记类型</span>
                <FmIcon name="material-symbols:expand-more-rounded" class="text-lg color-[#666]" />
              </div>
            </div>
          </div> -->
          <vxe-table header-row-class-name="table-header" :data="list">
            <vxe-column width="20%" field="time" title="时间" />

            <vxe-column field="name" title="名称" width="30%">
              <template #default="{ row }">
                <div class="text-15px font-500">
                  {{ row.name }}
                </div>
                <div class="text-13px">
                  {{ row.code }}
                </div>
              </template>
            </vxe-column>
            <vxe-column field="per" title="异动条件" width="25%" align="center">
              <template #default="{ row }">
                <div class="text-15px font-500" :style="{ color: row.type === 1 ? '#22A875' : '#E51A2D' }">
                  {{ row.per }}
                </div>
              </template>
            </vxe-column>
            <vxe-column field="data" title="异动数据" width="25%" align="right">
              <template #default="{ row }">
                <div class="text-15px font-500" :style="{ color: row.type === 1 ? '#22A875' : '#E51A2D' }">
                  {{ row.data }}
                </div>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </van-list>
    </div>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}
</style>
